import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function BoardErrorState({ message, onRetry }) {
  const isNetworkError = /^(failed to fetch|load failed|networkerror when attempting to fetch resource\.?)$/i.test(message?.trim());
  const displayMessage = isNetworkError
    ? 'Mini Görev’e şu an ulaşamıyoruz. İnternet bağlantını kontrol edip biraz sonra yeniden deneyebilirsin.'
    : message;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#fff7ed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
      }}
    >
      <Box sx={{ maxWidth: 560, textAlign: 'center', bgcolor: '#fff', borderRadius: 2, p: 4, border: '2px solid #fed7aa' }}>
        <Typography sx={{ fontSize: 48, lineHeight: 1, mb: 1 }}>🔗</Typography>
        <Typography sx={{ fontWeight: 900, color: '#9a3412', fontSize: 28, mb: 1 }}>Mini Görev açılamadı</Typography>
        <Typography role="alert" sx={{ color: '#475569', fontWeight: 700, mb: 3 }}>{displayMessage}</Typography>
        {onRetry && (
          <Button variant="contained" onClick={onRetry} sx={{ borderRadius: 2, fontWeight: 900 }}>
            Yeniden dene
          </Button>
        )}
      </Box>
    </Box>
  );
}
